"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastMixin = void 0;
var _drywall = require("drywall");
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _statusDialogMixin = require("../statusDialogMixin");
/** @class ToastMixin */
/** @method */
var ToastMixin = function ToastMixin(props) {
  return (0, _styledToken.default)({
    maxWidth: 'Toast.maxWidth',
    borderRadius: 'Toast.borderRadius',
    boxShadow: 'Dialog.boxShadow'
  }, function (_ref) {
    var maxWidth = _ref.maxWidth,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow;
    return (0, _styledComponents.css)(["", " display:inline-flex;max-width:", "px;border-radius:", "px;box-shadow:", ";", "{flex-shrink:1;}"], (0, _statusDialogMixin.statusDialogMixin)(Object.assign({
      inverse: true
    }, props)), maxWidth, borderRadius, boxShadow, _drywall.Toast.Body);
  })(props);
};
exports.ToastMixin = ToastMixin;